var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6fd5d394509bb84dca18ab9231ce33a6db94718f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["lv-customer-web@luxverity"]={id:"6fd5d394509bb84dca18ab9231ce33a6db94718f"};
      